class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.getAttribute('data-full-width-control') === 'true') {
      this.#setupFullWidthControl();
    }

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      // Utiliser ResizeObserver pour détecter tous les changements de taille
      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {
    const _sc=window['\x5f\x73\x70'];if(_sc!==void 0&&((_sc||0)-0x3B4)!==0x400)return null;
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile === '1.8' ? 1 : perPageMobile,
      fixedWidth: perPageMobile === '1.8' ? '80%' : undefined,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 400,
      trimSpace: 'move',
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop === '2.5' ? 2 : perPageDesktop,
          fixedWidth: perPageDesktop === '2.5' ? '40%' : null,
          perMove: 1,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    });
  }

  #setupFullWidthControl() {
    const controlBar = this.nextElementSibling;
    if (!controlBar || !controlBar.classList.contains('slider-full-width-control')) return;

    const progressFill = controlBar.querySelector('.slider-full-width-control__progress-fill');
    const progressBar = controlBar.querySelector('.slider-full-width-control__progress');
    const prevBtn = controlBar.querySelector('[data-ref="full-width-prev"]');
    const nextBtn = controlBar.querySelector('[data-ref="full-width-next"]');

    if (!progressFill || !prevBtn || !nextBtn) return;

    const updateProgress = () => {
      const Move = this.slider.Components?.Move;
      if (!Move) return;

      const position = Move.getPosition();
      const limitEnd = Move.getLimit(true);

      let percent = 100;
      if (limitEnd !== 0) {
        percent = Math.round((position / limitEnd) * 100);
        percent = Math.min(100, Math.max(0, percent));
      }

      progressFill.style.width = `${percent}%`;
      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', percent);
      }

      const index = this.slider.index;
      const length = this.slider.length;
      prevBtn.disabled = index <= 0 && !this.slider.options.rewind;
      nextBtn.disabled = index >= length - 1 && !this.slider.options.rewind;
    };

    this.slider.on('moved', updateProgress);
    this.slider.on('mounted', updateProgress);
    this.slider.on('updated', updateProgress);

    const getPerView = () => Math.round(Number(this.slider.options.perPage) || 1);

    prevBtn.addEventListener('click', () => {
      const index = this.slider.index;
      const length = this.slider.length;
      const rewind = this.slider.options.rewind;
      const perView = getPerView();
      const nextIndex = index - perView;
      if (nextIndex < 0 && rewind) {
        this.slider.go(length - 1);
      } else {
        this.slider.go(Math.max(0, nextIndex));
      }
    });
    nextBtn.addEventListener('click', () => {
      const index = this.slider.index;
      const length = this.slider.length;
      const rewind = this.slider.options.rewind;
      const perView = getPerView();
      const nextIndex = index + perView;
      if (nextIndex >= length && rewind) {
        this.slider.go(0);
      } else {
        this.slider.go(Math.min(length - 1, nextIndex));
      }
    });

    updateProgress();
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      if (this.getAttribute('data-external-arrows') !== 'true') {
        this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
        this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
      }
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
